import { Component, Input } from '@angular/core';
import { Organisation } from '../../models/organisation';

@Component({
    selector: 'app-organisation-data-grid',
    templateUrl: './organisation-data-grid.component.html',
    styleUrls: ['./organisation-data-grid.component.sass'],
    standalone: false
})
export class OrganisationDataGridComponent {
  @Input() organisations: Organisation[] = []
  @Input() loading: boolean = true;
  @Input() searchTerm: string = '';
  
  get noOrgsFound(): boolean {
    return !this.organisations || this.organisations.length == 0;
  }

  trackByItemId(index: number, item: Organisation): string {
    return item.referenceId;
  }

}
